import React from "react";
import {
  FormDataConsumer,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  required
} from "react-admin";

const ExpiringInsurerInput = props => (
  <FormDataConsumer>
    {({ formData }) => {
      const isBusinessTypeOne =
        Number(formData?.bzTypeId) === 1;

     if (isBusinessTypeOne) {
        return (
          <TextInput
            {...props}
            source="expiringInsurerId"
            label="Expiring Insurer"
            fullWidth
            disabled
            validate={
                      isBusinessTypeOne
                        ? []
                        : [required()]
                    }
            value=""
          />
        );
      }

      return (
        <ReferenceInput
          {...props}
          source="expiringInsurerId"
          reference="insurers"
            validate={
              isBusinessTypeOne
                ? []
                : [required()]
            }
          perPage={1000}
          sort={{ field: "name", order: "ASC" }}
          enableGetChoices={({ q }) => !!q && q.length >= 2}
        >
          <AutocompleteInput
            optionText="name"
            debounce={1000}
            filterToQuery={q => ({ q })}
            disabled={isBusinessTypeOne}
            validate={
              isBusinessTypeOne
                ? []
                : [required()]
            }
          />
        </ReferenceInput>
      );
    }}
  </FormDataConsumer>
);

export default ExpiringInsurerInput;